import { render, staticRenderFns } from "./CardSelfie.vue?vue&type=template&id=dd9219c2&scoped=true&"
import script from "./CardSelfie.vue?vue&type=script&lang=js&"
export * from "./CardSelfie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9219c2",
  null
  
)

export default component.exports